import { faGift } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { cva, type VariantProps } from "class-variance-authority";

const stampcardRewardBadgeStyles = cva(
  "flex items-center justify-center rounded-full bg-kiosk-accent-secondary text-kiosk-text-primary",
  {
    variants: {
      size: {
        sm: "size-10",
        md: "size-14"
      }
    },
    defaultVariants: {
      size: "md"
    }
  }
);

type StampcardRewardBadgeProps = VariantProps<
  typeof stampcardRewardBadgeStyles
>;

export const StampcardRewardBadge = ({ size }: StampcardRewardBadgeProps) => {
  return (
    <div className={stampcardRewardBadgeStyles({ size })}>
      <FontAwesomeIcon icon={faGift} size={size === "sm" ? "lg" : "2x"} />
    </div>
  );
};
